import React from 'react';
import { Box, Grid } from '@mui/material';

import { type PaginatorType } from 'app/main/components/hooks/usePaginator';
import { type SelectionProps } from 'app/main/components/hooks/useSelection';
import Pagination from 'app/main/components/filter/Pagination';

export interface ViewFooterCustomInfoProps {
	items: any[];
	selectedItems?: SelectionProps['selectedItems'];
	additionalInfo: any;
}

export interface ViewFooterProps {
	paginatorProps: PaginatorType;
	customInfo?: React.ReactNode;
}

export default function ViewFooter(props: ViewFooterProps) {
	return (
		<Box className="p-8" sx={theme => ({ borderTop: `1px solid ${theme.palette.divider}` })}>
			<Grid container justifyContent="space-between" alignItems="stretch" spacing={1}>
				{props.customInfo && <Grid size={{ sm: 'grow', xs: 12 }}>{props.customInfo}</Grid>}
				<Grid size={{ sm: 'grow', xs: 12 }}>
					<Box justifyContent="flex-end" alignItems="center">
						<Pagination {...props.paginatorProps} />
					</Box>
				</Grid>
			</Grid>
		</Box>
	);
}
